import { inflate } from "pako"

const decompressSxData = (encoded: string) => {
  try {
    // Convert from URL-safe base64
    const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/")
    // Add padding if needed
    const paddedBase64 = base64 + "=".repeat((4 - (base64.length % 4)) % 4)

    const compressed = Buffer.from(paddedBase64, "base64")

    // Convert Buffer to Uint8Array and decompress
    const uint8Array = new Uint8Array(compressed)
    const decompressedData = inflate(uint8Array, { to: "string" })
    const data = JSON.parse(decompressedData)

    // Convert back to original format
    if (Array.isArray(data)) {
      return data.map(bet => ({
        marketHash: bet.mh, // marketHash
        outcome: bet.o, // outcome
        percentageOdds: bet.po, // percentageOdds
        outcomeOneName: bet.on, // outcomeOneName
        outcomeTwoName: bet.tn, // outcomeTwoName
        isMakerBettingOutcomeOne: bet.mb, // isMakerBettingOutcomeOne
        marketName: bet.mn, // marketName
        chainId: bet.c, // chainId
        txHash: bet.tx, // txHash
        game: bet.g, // game
        odds: bet.od, // odds
        uniqueId: bet.ui, // uniqueId
        baseToken: bet.bt, // baseToken
        gameLabel: bet.gl, // gameLabel
        betAmount: bet.ba, // betAmount
        totalOdds: bet.to, // totalOdds
        betToken: bet.bto, // betToken
        selectedCollateralSymbol: bet.sc, // selectedCollateralSymbol
        live: bet.l, // live
        allOdds: bet.ao, // allOdds
      }))
    } else {
      return {
        marketHash: data.mh, // marketHash
        outcome: data.o, // outcome
        percentageOdds: data.po, // percentageOdds
        outcomeOneName: data.on, // outcomeOneName
        outcomeTwoName: data.tn, // outcomeTwoName
        isMakerBettingOutcomeOne: data.mb, // isMakerBettingOutcomeOne
        marketName: data.mn, // marketName
        chainId: data.c, // chainId
        txHash: data.tx, // txHash
        game: data.g, // game
        odds: data.od, // odds
        uniqueId: data.ui, // uniqueId
        baseToken: data.bt, // baseToken
        gameLabel: data.gl, // gameLabel
        betAmount: data.ba, // betAmount
        totalOdds: data.to, // totalOdds
        betToken: data.bto, // betToken
        selectedCollateralSymbol: data.sc, // selectedCollateralSymbol
        live: data.l, // live
        allOdds: data.ao, // allOdds
      }
    }
  } catch (error) {
    console.error("SX decompression error:", error)
    throw error
  }
}

export default decompressSxData
